export default __webpack_public_path__ + "static/media/pass-hide.f002a9a3.png";